/* 生成随机数 */
export function getRandom(start, end, fixed = 0) {
  let differ = end - start;
  let random = Math.random();
  return Number((start + differ * random).toFixed(fixed));
}

export function getRanddoms(start, end, len = 1, fixed = 0) {
  let arr = [];
  for (; len > 0; len--) {
    arr.push(getRandom(start, end, fixed));
  }
  return arr;
}

/* 查找 array index by name */
export function findIndexByName(name, arr, findname = "name", subname = null) {
  let index = -1;
  for (let i = 0; i < arr.length; i++) {
    if (subname) {
      if (arr[i][findname][subname] === name) {
        // 两层
        //   return i;
        index = i;
        break;
      }
    } else {
      if (arr[i][findname] === name) {
        //   return i;
        index = i;
        break;
      }
    }
  }
  return index;
}

// 判断是否是图片资源
export function isPic(str) {
  try {
    const suffix = str.split(".")[1].toLocaleLowerCase();
    const imglist = [
      "svgz",
      "pjp",
      "png",
      "ico",
      "avif",
      "tiff",
      "tif",
      "jfif",
      "svg",
      "xbm",
      "pjpeg",
      "webp",
      "jpg",
      "jpeg",
      "bmp",
      "gif"
    ];
    // 进行图片匹配
    const result = imglist.find(item => item === suffix);
    if (result) {
      return true;
    } else {
      return false;
    }
  } catch {
    // throw new Error("请上传图片文件")
    return false;
  }
}

// 文件类型判断
export function checkFile(fileValue) {
  if (!fileValue) {
    return false;
  }
  const index = fileValue.lastIndexOf(".");
  const fileValueSuffix = fileValue.substr(index + 1).toLocaleLowerCase();
  console.log("fileValueSuffix", fileValue, fileValueSuffix);
  if (/^(mp4|avi|wmv)$/.test(fileValueSuffix)) {
    //根据后缀，判断是否符合视频格式
    return "video";
  } else if (/^(bmp|mpg|webp|jpg|jpeg|gif|svg|png)$/.test(fileValueSuffix)) {
    //根据后缀，判断是否符合图片格式
    return "image";
  } else if (/^(xls|xlsx|doc|docx|pdf|ppt|pptx)$/.test(fileValueSuffix)) {
    //根据后缀，判断是否符合OFFICE格式
    return "office";
  }
  return false;
}
